
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/places-to-go/[slug]",
      function () {
        return require("private-next-pages/places-to-go/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/places-to-go/[slug]"])
      });
    }
  